import { Link as NavLink } from "react-router-dom";

export const Footer = () => {
  return (
    <div className="footer bg-black">
      <div className="border-t border-[#fff3]">
        <div className="container mx-auto py-5">
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div className="text-[10px] md:text-[12px] text-center md:text-left text-[#ffffff] font-inter opacity-50">
              © {new Date().getFullYear()} TWO12 Inc.  All Rights Reserved. Certain features of our software are protected under a provisional patent filing with the USPTO.
            </div>

            <div className="flex items-center gap-4 justify-center md:justify-between">
              <NavLink
                className="text-[10px] md:text-[12px] text-[#ffffff80] font-dmSans"
                to="/legal/terms-of-service"
              >
                Terms of Service
              </NavLink>

              <NavLink
                className="text-[10px] md:text-[12px]  text-[#ffffff80] font-dmSans"
                to="/legal/data-use-policy"
              >
                Data Use Policy
              </NavLink>

              <NavLink
                className="text-[10px] md:text-[12px]  text-[#ffffff80] font-dmSans"
                to="/legal/privacy-policy"
              >
                Privacy Policy
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
